import DeselectIcon from '@/assets/icons/icon-deselect.svg'
import SelectIcon from '@/assets/icons/icon-select.svg'
import { classNames } from '@/utils/helpers'

interface DeselectButtonProps {
  onToggle: (val: boolean) => void
  isSelected: boolean
  disabled?: boolean
}
const iconClassNames = 'w-[0.8rem] h-[0.8rem] cursor-pointer'

export const DeselectButton = ({
  isSelected,
  onToggle,
  disabled,
}: DeselectButtonProps) => {
  return isSelected ? (
    <DeselectIcon
      onClick={() => onToggle(false)}
      className={classNames(
        iconClassNames,
        'text-danger-default hover:text-danger-dark',
        disabled && 'pointer-events-none cursor-not-allowed opacity-50',
      )}
    />
  ) : (
    <SelectIcon
      onClick={() => onToggle(true)}
      className={classNames(
        iconClassNames,
        'text-primary-500 hover:text-primary-600',
        disabled && 'pointer-events-none cursor-not-allowed opacity-50',
      )}
    />
  )
}
